import { FaPaypal, FaStripe } from 'react-icons/fa';
import { FiChevronsRight } from 'react-icons/fi';
import { MdPayment } from 'react-icons/md';

export const PAYMENT_PROVIDERS = {
    stripe: {
        label: 'Stripe',
        icon: FaStripe,
    },
    liqpay: {
        label: 'LiqPay',
        icon: FiChevronsRight,
    },
    paypal: {
        label: 'PayPal',
        icon: FaPaypal,
        supported_currencies: [
            'AUD',
            'BRL',
            'CAD',
            'CNY',
            'CZK',
            'DKK',
            'EUR',
            'HKD',
            'HUF',
            'ILS',
            'JPY',
            'MYR',
            'MXN',
            'TWD',
            'NZD',
            'NOK',
            'PHP',
            'PLN',
            'GBP',
            'RUB',
            'SGD',
            'SEK',
            'CHF',
            'THB',
            'USD',
        ],
    },
    wayforpay: {
        label: 'Wayforpay',
        icon: MdPayment,
    },
    robokassa: {
        label: 'Robokassa',
        icon: MdPayment,
    },
};
